import "./gallery.scss";
import "../../../js/core";
import "../../../components/site-elements/other-blocks/tags/expand-tags/expand-tags";
import * as loadMoreGallery from "jquery";

let searchClear = document.getElementById("searchclear");
let searchInput = document.getElementById("searchinput");

searchClear.addEventListener("click", function () {
  searchInput.value = "";
  searchClear.style.display = "none";
});

document.addEventListener("keyup", function () {
  if (searchInput.value.length) {
    searchClear.style.display = "inherit";
  } else {
    searchClear.style.display = "none";
  }
});

let galleryLoadMore = $("#gallery_load_more");
let sectionGallery = $(".section-gallery");
let currentPage = galleryLoadMore.data("current-page");
let clickSearch = 0;
galleryLoadMore.on("click", function () {
  $(this).addClass("is-loading loading-start").attr("disabled", true);

  let ajaxUrl = `${location.protocol}//${location.hostname}${
    location.port ? ":" + location.port : ""
  }/wp-admin/admin-ajax.php`;
  let galleryPosts = $(this).data("gallery-posts");
  let galleryUrl = $(this).data("gallery-url");
  let postPerLoad = $(this).data("post-per-page");
  let search = $(".result-search span").text();
  let maxPages = $(this).data("max-pages");
  let termsArr = sectionGallery.data("terms-arr");
  let postIdsArr = galleryLoadMore.data("post-ids-arr");

  let data = {
    action: "gallery_ajax_search",
    query: galleryPosts,
    paged: currentPage,
    gallery_url: galleryUrl,
    "post-per-load": postPerLoad,
    "gallery-search": search,
    terms_arr: termsArr,
    post_ids_arr: postIdsArr,
    "click-search": clickSearch,
  };
  $.ajax({
    url: ajaxUrl,
    data: data,
    type: "POST",
    success: function (results) {
      if (results) {
        galleryLoadMore
          .removeClass("is-loading loading-start")
          .removeAttr("disabled");
        let res = JSON.parse(results);
        $(".gallery-posts-js").append(res.posts);
        currentPage++;
        galleryLoadMore.data("current-page", currentPage);
        galleryLoadMore.data("post-ids-arr", res.post_ids_arr);

        if (currentPage == res.pages) $("#gallery_load_more").hide("fast");

        setTimeout(function () {
          $("#blog-articles")
            .find(".card-animation")
            .removeClass("card-animation");
        }, 1);
      } else {
        $("#gallery_load_more").hide("fast");
      }
    },
  });
});

let searchValue = "";

$(".btn-search").on("click", function (event) {
  event.preventDefault();
  clickSearch = 1;
  currentPage = 1;
  let searchInput = $("#searchinput");
  let searchClear = $("#searchclear");
  searchValue = searchInput.val();

  if (searchValue.length > 2) {
    searchInput.val("");
    searchClear.empty();
    $(".tags-container").hide();
    $(".result-search")
      .show()
      .html(`Search Results for: <span>${searchValue}</span>`);
    $(".result-search > span").text(searchValue);
    $("#blog-articles").empty();
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "POST",
      data: {
        action: "gallery_ajax_search",
        "gallery-search": searchValue,
        "click-search": clickSearch,
      },
      success: function (results) {
        let res = JSON.parse(results);
        let galleryLoadMore = $("#gallery_load_more");
        galleryLoadMore.attr("data-gallery-posts", res.data_gallery_posts);
        galleryLoadMore.attr("data-max-pages", res.data_max_pages);
        galleryLoadMore.attr("data-gallery-search", searchValue);
        $("#blog-articles").fadeIn("fast").html(res.posts);

        if (res.pages <= 1) {
          $(".btn-load-more-js").fadeOut("fast");
        } else {
          $(".btn-load-more-js").fadeIn("fast");
        }
      },
    });
  } else {
    $(".result-search").css("display", "none");
    loadMoreGallery.removeAttr("data-gallery-search");
  }
});

$(".tag-js").on("click", function (event) {
  event.preventDefault();
  let galleryLoadMore = $("#gallery_load_more");
  let ajaxUrl = `${location.protocol}//${location.hostname}${
    location.port ? ":" + location.port : ""
  }/wp-admin/admin-ajax.php`;
  let galleryPosts = galleryLoadMore.data("gallery-posts");
  currentPage = 1;
  let galleryUrl = galleryLoadMore.data("gallery-url");
  let postPerLoad = galleryLoadMore.data("post-per-page");
  let postIdsArr = galleryLoadMore.data("post-ids-arr");
  let termsArr = sectionGallery.data("terms-arr");

  $(this).parent("li").toggleClass("active");
  let termId = $(this).data("term-id");
  let termTaxonomy = $(this).data("term-taxonomy");

  // Create selected 'gallery_tags' taxonomy array
  if (termTaxonomy === "gallery_tags") {
    let index = termsArr.gallery_tags.indexOf(termId);

    if (index > -1) {
      termsArr.gallery_tags.splice(index, 1);
    } else {
      termsArr.gallery_tags.push(termId);
    }
  }

  // Create selected 'gallery_satellites' taxonomy array
  if (termTaxonomy === "gallery_satellites") {
    let index = termsArr.gallery_satellites.indexOf(termId);

    if (index > -1) {
      termsArr.gallery_satellites.splice(index, 1);
    } else {
      termsArr.gallery_satellites.push(termId);
    }
  }

  let data = {
    action: "gallery_ajax_search",
    query: galleryPosts,
    paged: currentPage,
    gallery_url: galleryUrl,
    "post-per-load": postPerLoad,
    post_ids_arr: postIdsArr,
    terms_arr: termsArr,
    is_filter: 1,
  };

  $.ajax({
    url: ajaxUrl,
    data: data,
    type: "POST",
    success: function (results) {
      let blogArticles = $("#blog-articles");
      let res = JSON.parse(results);

      blogArticles.hide().empty().fadeIn("fast").html(res.posts);

      if (res.pages <= 1) {
        $(".btn-load-more-js").fadeOut("fast");
      } else {
        $(".btn-load-more-js").fadeIn("fast");
      }
    },
  });
});
